<template>
  <div class="comments" >
    <van-row class="my_guardian">
      <van-col span="22" offset="1" v-if="is_list">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :finished-text="$t('onLoad.finished_text')"
          @load="onLoad"
          :offset="10"
        >
          <van-cell v-for="t in list" :key="t.id">
            <van-col span="24" class="my_visitor_type" @click="user_Jump(t.uid)">
              <van-col span="5" class="my_visitor_type_img">
                <van-image round width="3.5em" height="3.5em" :src="t.avatar" fit="cover"/>
              </van-col>
              <van-col span="15">
                <van-col span="24" class="my_visitor_type_name">{{ t.user_nickname }}</van-col>
                <van-col span="8" :class="[t.sex === 1 ? 'my_visitor_type_sex1':'my_visitor_type_sex2']">
                  <van-col class="my_visitor_type_sex3" span="6" offset="2" v-if="t.sex === 1">
                  </van-col>
                  <van-col class="my_visitor_type_sex4" span="6" offset="2" v-else>
                  </van-col>
                  <van-col span="15" class="my_visitor_type_age">
                    <span  class="my_visitor_type_age_yes" v-if="t.age">{{ t.age }}{{ $t('other.age') }}</span>
                    <span class="my_visitor_type_age_no" v-else>{{ $t('user.AgedeFault') }}</span>
                  </van-col>
                </van-col>
              </van-col>
              <van-col span="4" class="my_visitor_type_time">{{ t.time }}</van-col>
            </van-col>
          </van-cell>
        </van-list>
      </van-col>
      <van-col span="24" v-else>
        <van-col span="24" class="no-data">
          <img src="../assets/img/zwsl.png"/>
        </van-col>
        <van-col span="24" class="no-data-name" >{{ $t('onLoad.No_record') }}</van-col>
      </van-col>
      <div span="24" v-if="is_vip && vip_avatar.length>0" class="visitor_bottom">
        <van-col span="18" offset="3">
          <van-col span="24">
             <span span="5" class="my_visitor_vip_avatar" v-for="t in vip_avatar" :key="t.id">
              <van-image round width="3em" height="3em" :src="t.avatar" fit="cover"/>
            </span>
            <span span="5" class="my_visitor_vip_img">
            <img src="../assets/img/vip_suo.png" />
          </span>
          </van-col>
          <van-col span="24" class="my_visitor_sum" v-if="sum"> {{ $t('other.also') }} <span>{{ sum }}{{ $t('other.position') }}</span> {{ $t('other.see_you') }} </van-col>
          <van-col span="24" class="my_visitor_center">{{ $t('other.Upgrade_membership') }}</van-col>
          <van-col span="24" class="my_visitor_btn">
            <van-button @click="vip_btn">{{ $t('other.See_more') }}</van-button>
          </van-col>
        </van-col>
      </div>
    </van-row>
  </div>
</template>
<script>
  //请求接口组件
  import '@/assets/css/style.css'
  import Toast from "vant/lib/toast"
  import axios from 'axios'
  import { Sticky, Dialog} from 'vant'
  import { judgeIosAndroid } from '@/assets/js/models.js'
  export default {
    data(){
      return {
        finished: false,
        loading: false,
        is_list: true,
        is_vip: false,
        sum: 0,
        vip_avatar: [],
        list: [],
        page: 1
      }
    },
    components: {
      [Sticky.name]: Sticky
    },
    created: function() {
      this.list = []
      this.convert();
      document.title = this.$t('title.visitor')
    },
    methods: {
      onLoad() {

        if(!this.is_vip) {
          this.convert()
        }
      },
      vip_btn() {
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        Dialog.confirm({
          title: this.$t('Tips.VIP_only'),
          message: this.$t('Tips.Quick_Unlock'),
          confirmButtonText: this.$t('btn.submit'),
          cancelButtonText: this.$t('btn.cancel'),
        }).then(() => {
            // 跳转充值页面
            this.$router.push({path:'/vip',query:{uid:uid, token: token }})
          }).catch(() => {});
      },
      convert: function() {
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + "mapi/public/index.php/api/user_api/get_user_visitor",{ params:{ uid:uid,token:token,page: this.page }}).then(res => {
          console.log(res.data);

          if (res.data.code == 1) {
            if (res.data.data.list.length > 0) {
              if (this.page == 1) {
                this.list = []
              }
              for (let i = 0; i < res.data.data.list.length; i++) {
                this.list.push(res.data.data.list[i]);
              }
              this.vip_avatar = res.data.data.vip_avatar
              this.is_vip = res.data.data.is_vip == 1 ? false : true
              this.sum = res.data.data.sum

              this.is_list = true
              this.page = this.page + 1
              this.loading = false
              this.finished = this.is_vip ? true : false
            } else {
              if(this.page == 1) {
                this.is_list = false
              }
              this.loading = true
              this.finished =true
            }
          } else {
            if(this.page == 1) {
              this.is_list = false
            }
            this.loading = true
            if(this.page !== 1) {
              Toast(this.$t('onLoad.No_data_available'))
            }
          }
        })
      },
      user_Jump (uid){
        //  拦截
        const isIos = judgeIosAndroid();
        if (isIos == true) {
          // ios传值方法postMessage（val）传值方式
          window.webkit.messageHandlers.homepage.postMessage(uid)
        } else {
          // ios传值方法goSubmitted（val）传值方式
          window.AndroidJs.homepage(uid)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/visitor.vue